@if (pureFilterStream$ | async; as filter) {
  <sh-form-multi-select-base
    [style]="style$ | async"
    [droppanelStyle]="filter.droppanelStyle"
    [id]="id$ | async"
    [formControl]="form"
    [search]="filter.search"
    [searchPlaceholderMsg]="filter.searchPlaceholderMsg"
    [noResultsFoundMsg]="filter.noResultsFoundMsg"
    [multiple]="filter.multiple"
    [options]="options$ | async"
    [isLoading]="loading"
    [loadingMsg]="filterLabels.loading"
    [noneSelectedMsg]="filterLabels.noneSelected"
    [multipleSelectedMsg]="filterLabels.multipleSelected"
    [allSelectedMsg]="filterLabels.allSelected"
    [prefixMsg]="prefix$ | async"
    [listCappedMsg]="filterLabels.listCapped"
    (searchTerm)="onSearchTermChange($event)"
    [autocompleteFct]="filter.autocomplete ? filter.autocompleteFct : null"
    [placeholderMsg]="filter.searchPlaceholderMsg"
  ></sh-form-multi-select-base>
} @else {
  <sh-form-multi-select-base
    [style]="style$ | async"
    [droppanelStyle]="undefined"
    [id]="id$ | async"
    [formControl]="form"
    [search]="undefined"
    [searchPlaceholderMsg]="undefined"
    [noResultsFoundMsg]="undefined"
    [multiple]="false"
    [options]="options$ | async"
    [isLoading]="loading"
    [loadingMsg]="filterLabels.loading"
    [noneSelectedMsg]="filterLabels.noneSelected"
    [multipleSelectedMsg]="filterLabels.multipleSelected"
    [allSelectedMsg]="filterLabels.allSelected"
    [prefixMsg]="prefix$ | async"
    [listCappedMsg]="filterLabels.listCapped"
    (searchTerm)="onSearchTermChange($event)"
    [autocompleteFct]="undefined"
    [placeholderMsg]="undefined"
  ></sh-form-multi-select-base>
}

